import React from "react";
import Button from "components/CustomButton";
import { Modal } from "react-responsive-modal";

var styles = {
  titleDailog: {
    padding: "24px 24px 10px",
    fontSize: "1.25rem",
    fontWeight: "900",
    marginBottom: "0",
  },
  headingDailog: {
    fontSize: "1rem",
    padding: "0px 24px",
    marginBottom: "12px",
  },
  actionButton: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    textAlign: "center",
    padding: "10px 8px",
  },
};

export default ({ strengthModal, setStrengthModal }) => {
  const classes = styles;

  return (
    <Modal
      open={strengthModal}
      onClose={() => setStrengthModal(false)}
      showCloseIcon={false}
      classNames={{ modalContainer: "modalContainer", modal: "modalPadding" }}
    >
      <div className="modal-body">
        <h2 style={classes.titleDailog}>User Strength Alert</h2>
        <h6 style={classes.headingDailog}>
          You can select only 3 strengths. If you want to select more kindly
          uncheck the previous one and then select again.
        </h6>
        <div style={classes.actionButton}>
          <Button
            buttonClass="small-btn me-2"
            onClick={() => {
              setStrengthModal(false);
            }}
          >
            Okay
          </Button>
        </div>
      </div>
    </Modal>
  );
};
